import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { useSelector } from 'react-redux';
import { useTileView } from '../../lib/redux/hooks/useTileView';
import { useGetTile } from './data';
import FullSizeTile from '../FullSizeTile';
import TileViewMenu from './TileViewMenu';

const TileView = ({ refetchTile, shouldRefetchTile }) => {
  const { setTileView } = useTileView();
  const { showTileView, tileId, currentTab } = useSelector(
    state => state.tileView,
  );
  const { activeStatus } = useSelector(state => state.status);
  const { data: tile, isLoading, refetch } = useGetTile({ tileId });
  const tiles = useSelector(state => {
    const tabTiles = Object.values(state.dndContext[activeStatus].tiles);
    if (currentTab === 'plan') {
      return tabTiles.filter(({ planDate }) => tile.planDate === planDate);
    }
    return tabTiles;
  });

  useEffect(() => {
    if (shouldRefetchTile) {
      refetch();
      refetchTile(false);
    }
  }, [shouldRefetchTile, refetchTile, refetch]);

  const changeTile = direction => {
    const currentIndex = tiles.findIndex(({ id }) => id === tileId);
    const directions = {
      next: index => (index === tiles.length - 1 ? 0 : index + 1),
      prev: index => (index === 0 ? tiles.length - 1 : index - 1),
    };

    const newIndex = directions[direction](currentIndex);

    setTileView({ currentTab, tileId: tiles[newIndex].id });
  };

  if (!showTileView) {
    return null;
  }

  return (
    <Wrapper>
      <TileContainer>
        {!isLoading && (
          <TileViewMenu
            currentTab={currentTab}
            tileId={tileId}
            editPath={tile.editPath}
            planDate={tile.planDate}
            creatorName={tile.creatorName}
            refetch={refetch}
          />
        )}
        <FullSizeTile
          tile={tile}
          loading={isLoading}
          tileOrigin="edit"
          nextTile={() => changeTile('next')}
          prevTile={() => changeTile('prev')}
          submitAnswer={() => {}}
        />
      </TileContainer>
    </Wrapper>
  );
};

TileView.propTypes = {
  refetchTile: PropTypes.func,
  shouldRefetchTile: PropTypes.bool,
};

export default TileView;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: ${themeGet('colors.background')};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 100px 0;
  overflow: auto;
`;

const TileContainer = styled.div``;
